import { lazy } from 'react';
import { LinkTo } from 'shared/constants/linkTo';
import { designerPageSsrProps } from 'shared/pages/designer/ssr/routesProps';
import commonRoutes from 'shared/routes/commonRoutes';

const CommDesignMainPage = lazy(() => import("shared/pages/commdesign/ru/CommDesignMainPage"));
const ConnectPage = lazy(() => import('shared/pages/connect'));
const DesignerPage = lazy(() => import("shared/pages/designer"));
const ExploreHseContextsLocal = lazy(() => import('shared/pages/exploreHseContextsNew/exploreHseContextsLocal'));
const ExploreView = lazy(() => import("shared/pages/explore"));
const Init = lazy(() => import('./pages/init'));
const NotFoundPage = lazy(() => import("shared/pages/notfound"));
const SelectGeoLocationTagsModal = lazy(() => import('shared/modals/SelectGeoLocationTagsModal'));
const WebinarPage = lazy(() => import('shared/pages/commdesign/ru/WebinarPage'));
const HsePageScraperController = lazy(() => import('../../core/controllers/HsePageScraperController'));

const ssrEmptyProps = { ssrEnabled: false, ssrComponent: undefined, ssrGetInitData: undefined, ssrOptions: undefined, redirectTo: '' }

export const getRoutesList = ({ context }: any) => [
    { path: LinkTo.designer, exact: true, component: () => <DesignerPage whiteTheme ignoreContext contexts={['hsedesign']} />, ...designerPageSsrProps },
    { path: "/about", exact: true, component: Init },
    { path: "/communication", exact: true, component: Init },
    { path: "/join", exact: true, component: Init },
    { path: "/news", exact: true, component: Init },
    { path: "/digital-product-design", exact: true, component: Init },
    { path: "/school/commdesign/1", exact: true, component: Init },
    { path: "/school/commdesign/2", exact: true, component: CommDesignMainPage },
    { path: "/school/commdesign/webinar", exact: true, component: WebinarPage },
    { path: "/pages/3386", exact: true, component: () => <HsePageScraperController id="3386" /> },
    { path: "/dop/programs/294", exact: true, component: () => <HsePageScraperController id="3442" /> },
    { path: "/design-days", exact: true, component: () => <HsePageScraperController id="5649" /> },
    { path: "/design-day-4", exact: true, component: () => <HsePageScraperController id="6341" /> },
    { path: "/info/registration_dod_erevan", exact: true, component: () => <HsePageScraperController id="2875" /> },
    { path: LinkTo.connect, exact: true, isPrivate: true, component: ConnectPage },
    { path: LinkTo.createLocation, exact: true, component: SelectGeoLocationTagsModal },
    { path: LinkTo.map, component: ExploreView },
    { path: LinkTo.mapEducation, component: ExploreView },
    { path: LinkTo.mapData, component: ExploreView },
    { path: LinkTo.mapIframe, component: ExploreView },
    { path: LinkTo.explore, exact: true, component: () => <ExploreHseContextsLocal context={context} />, ...ssrEmptyProps },

    ...commonRoutes(),

    { path: '*', exact: true, component: NotFoundPage },
]
import { lazy } from 'react';
import { LinkTo } from 'shared/constants/linkTo';
import { designerPageSsrProps } from 'shared/pages/designer/ssr/routesProps';
import commonRoutes from 'shared/routes/commonRoutes';

const CommDesignMainPage = lazy(() => import("shared/pages/commdesign/ru/CommDesignMainPage"));
const ConnectPage = lazy(() => import('shared/pages/connect'));
const DesignerPage = lazy(() => import("shared/pages/designer"));
const ExploreHseContextsLocal = lazy(() => import('shared/pages/exploreHseContextsNew/exploreHseContextsLocal'));
const ExploreView = lazy(() => import("shared/pages/explore"));
const Init = lazy(() => import('./pages/init'));
const NotFoundPage = lazy(() => import("shared/pages/notfound"));
const SelectGeoLocationTagsModal = lazy(() => import('shared/modals/SelectGeoLocationTagsModal'));
const WebinarPage = lazy(() => import('shared/pages/commdesign/ru/WebinarPage'));
const HsePageScraperController = lazy(() => import('../../core/controllers/HsePageScraperController'));

const ssrEmptyProps = { ssrEnabled: false, ssrComponent: undefined, ssrGetInitData: undefined, ssrOptions: undefined, redirectTo: '' }

export const getRoutesList = ({ context }: any) => [
    { path: LinkTo.designer, exact: true, component: () => <DesignerPage whiteTheme ignoreContext contexts={['hsedesign']} />, ...designerPageSsrProps },
    { path: "/about", exact: true, component: Init },
    { path: "/communication", exact: true, component: Init },
    { path: "/join", exact: true, component: Init },
    { path: "/news", exact: true, component: Init },
    { path: "/digital-product-design", exact: true, component: Init },
    { path: "/school/commdesign/1", exact: true, component: Init },
    { path: "/school/commdesign/2", exact: true, component: CommDesignMainPage },
    { path: "/school/commdesign/webinar", exact: true, component: WebinarPage },
    { path: "/pages/3386", exact: true, component: () => <HsePageScraperController id="3386" /> },
    { path: "/dop/programs/294", exact: true, component: () => <HsePageScraperController id="3442" /> },
    { path: "/design-days", exact: true, component: () => <HsePageScraperController id="5649" /> },
    { path: "/design-day-4", exact: true, component: () => <HsePageScraperController id="6341" /> },
    { path: "/info/registration_dod_erevan", exact: true, component: () => <HsePageScraperController id="2875" /> },
    { path: LinkTo.connect, exact: true, isPrivate: true, component: ConnectPage },
    { path: LinkTo.createLocation, exact: true, component: SelectGeoLocationTagsModal },
    { path: LinkTo.map, component: ExploreView },
    { path: LinkTo.mapEducation, component: ExploreView },
    { path: LinkTo.mapData, component: ExploreView },
    { path: LinkTo.mapIframe, component: ExploreView },
    { path: LinkTo.explore, exact: true, component: () => <ExploreHseContextsLocal context={context} />, ...ssrEmptyProps },

    ...commonRoutes(),

    { path: '*', exact: true, component: NotFoundPage },
]
